import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from './redux';
import { GameNav } from './component';


export default connect(mapStateToProps, mapDispatchToProps)(GameNav);
